import React from "react";

import { formatBytes } from "utils/format";

import { useReplicationDetailsGraphQuery } from "./gql/Query.generated";
import { useDateRange } from "components/WithDateRange";
import { Data } from "components/Graph/util";

import DateRangeGraph from "components/Graph/DateRangeGraph";
import GraphSection from "components/Graph/GraphSection";
import { AreaSeries } from "components/Graph/Series";

type Props = {
  serverId: string;
  replicationFollowerId: string;
};

const Graph: React.FunctionComponent<Props> = ({
  serverId,
  replicationFollowerId,
}) => {
  const { from, to } = useDateRange();

  const { data, loading, error } = useReplicationDetailsGraphQuery({
    variables: {
      serverId,
      replicationFollowerId,
      startTs: from.unix(),
      endTs: to.unix(),
    },
  });

  return (
    <GraphSection loading={loading} error={error}>
      <DateRangeGraph
        data={data?.getReplicationFollowerStats as unknown as Data}
        axes={{ left: { format: formatBytes } }}
        series={[
          {
            key: "totalByteLag",
            label: "Total Byte Lag",
            color: "mediumSeaGreen",
          },
          {
            key: "remoteByteLag",
            label: "Remote Byte Lag",
            type: AreaSeries,
            color: "lime",
          },
          {
            key: "localByteLag",
            label: "Local Byte Lag",
            type: AreaSeries,
            color: "yellowGreen",
          },
        ]}
      />
    </GraphSection>
  );
};

export default Graph;
